export default "__VITE_ASSET__Ba4E6p98__"